import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/auth.vue").then(m => m.default || m)),
  base: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/base.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/empty.vue").then(m => m.default || m)),
  "sidebar-less": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/sidebarLess.vue").then(m => m.default || m))
}